export default __webpack_public_path__ + "static/media/ai.53bc0c5b.jpg";